import React, { ReactElement } from 'react';
import { Menu } from '@headlessui/react';
import { LanguageIcon } from '@heroicons/react/24/outline';
import { useLanguage } from '@plerionhq/design-system/i18n';

/**
 * One menu entry per available locale. Renders nothing while English is the
 * only locale on disk, so the profile menu is unchanged until a second one
 * ships.
 */
export function LanguageMenuItems(): ReactElement | null {
  const { current, locales, canSwitch, select } = useLanguage();

  if (!canSwitch) {
    return null;
  }

  return (
    <>
      {locales.map((locale) => (
        <Menu.Item key={locale.code}>
          {({ active }) => (
            <button
              onClick={() => void select(locale.code)}
              className={`${active ? 'bg-br-primary/10' : ''} ${locale.code === current ? 'text-br-primary dark:text-br-secondary' : 'text-gray-700 dark:text-gray-300'} flex w-full items-center gap-2 px-4 py-2 text-sm`}
              data-testid={`profile-dropdown-language-${locale.code}`}
              aria-current={locale.code === current}
            >
              <LanguageIcon className="h-4 w-4" />
              {locale.label}
            </button>
          )}
        </Menu.Item>
      ))}
    </>
  );
}
